import axios from '../utils/axios';

export default function updateShowcaseV2Plan(adminId, data) {
    return (
        axios.post(`/admin/${adminId}/update-showcase-v2-plan`, data)
    )
}
